module.exports = __webpack_public_path__ + "img/pic_australia_06.c4883a68.jpg";